export default "__VITE_ASSET__DnS4zWNk__"